<template>
  <div id="app">
    <home></home>
    <!-- <router-view/> -->
  </div>
</template>
<script>
import home from "./components/home.vue";

export default {
  name: "App",
  components: {
    home,
  },
};
</script>
<style>
#__vconsole {
  display: none;
}
#__vconsole.show {
  display: block !important;
}
#app {
  font-family: "微软雅黑", "Microsoft YaHei", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  background: #fbfcff;
}
html,
body,
#app {
  height: 100vh;
  margin: 0;
  padding: 0;
  border: none;
  overflow: auto;

  /* min-width: 1200px; */
}
</style>
